/**
 * Created by Dhanya Akhil on 3/24/2017.
 */
import { Inject, Injectable } from '@angular/core';


@Injectable()
export class ChartConfigService {

  public legendCharts;
  public barChartOptions;
  constructor(){

  }

/*  public barChartOptions:any = {
    legend: {position: 'bottom'},
    tooltips: {
      callbacks: {
        enabled: true,
        label: function(tooltipItems, data) {
          var serie = data.datasets[tooltipItems.datasetIndex].label;
          var result = serie + ':' + tooltipItems.yLabel + ' %';
          if (tooltipItems.datasetIndex > 0) {
            result = 'Benchmark:' + tooltipItems.yLabel + ' %';
          }
          return result;
        }
      }
    },
    scales: {
      xAxes: [{
        spanGaps : true,
        ticks : {
          min : 0,
          beginAtZero : true
        },
        gridLines : {
          display : false
        },
        scaleLabel: {
          display: true
        }
      }],
      yAxes: [{
        spanGaps : false,
        ticks: {
          beginAtZero: true,
          max: 100,
          min: 0,
          stepSize: 25
        },
        gridLines : {
          display : true
        }
      }]
    }
  };*/

 public chartOptions(yMin, yMax){
   this.legendCharts = [];
   this.barChartOptions = {
     legend:{
       display: true,
       position: 'bottom',
     },
     responsive: true,
     borderWidth: 1,
     legendCallback: function (chart) {
       this.legendChart = '';
       var text = [];
       text.push('<ul>');
       for (var i = 0; i < chart.data.datasets.length; i++) {
         text.push('<li class="legendLi" id="legendLi-' + i + '">');
         text.push('<span class="legendSpan"  value="' + chart.legend.legendItems[i].datasetIndex + '" style="background-color:' + chart.data.datasets[i].backgroundColor + '"">' + '</span>');
         if (chart.data.datasets[i]) {

           text.push(chart.data.datasets[i].label);

         }
         text.push('</li>');
       }
       text.push('</ul>');
       this.setClickParam(chart)
       return text.join("");

     },
     tooltips: {
       callbacks: {
         enabled: true,
         label: function (tooltipItems, data) {
           var serie = data.datasets[tooltipItems.datasetIndex].label;
           var result = serie + ':' + tooltipItems.yLabel + ' %';
           if (tooltipItems.datasetIndex > 0) {
             result = 'Benchmark:' + tooltipItems.yLabel + ' %';
           }
           return result;
         }
       }
     },
     scales : {
       yAxes : [ {
         barPercentage:1.0,
         ticks : {
           min : yMin,
           max : yMax,
           beginAtZero : true,
           callback: function(label, index, labels) {
             return label + ' %';
           }
         },
         spanGaps : true,
         gridLines : {
           display : false,
           drawBorder: false
         },
         scaleLabel: {
           display: true
         }
       } ],
       xAxes : [ {
         barPercentage:1.0,
         ticks : {
           min : 0,
           beginAtZero : true
         },
         spanGaps : true,
         gridLines : {
           display : false,
           drawBorder: false,
         }
       } ]
     }
 }
 return this.barChartOptions;
 }
  public barChartColors:Array<any> = [
    { // first color
      backgroundColor: '#0A6B7C'
    },
    { // second color
      backgroundColor: '#8EE3CE'
    }];


}
